import React, { useEffect } from "react";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import ReViewTable from "./ReviewTable";

const ProductReview = () => {

  useEffect(() => {
    document.title = "Product Review | Dashboard";
  }, []);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Product Review" pageTitle="Dashboard" />

        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                {/* <SearchTable /> */}
                <div className="table-responsive">
                  <ReViewTable />
                </div>

              </CardBody>
            </Card>
          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default ProductReview;